export class MenuClass {

    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.content = data.content;
    }
}